import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { UiLegacy } from "@silvertours/front-legacy-shared";
var generateTimeRange = function() {
    var options = [];
    for(var m = 0; m < 1440; m += 15){
        var time = "".concat(Math.floor(m / 60).toString().padStart(2, "0"), ":").concat((m % 60).toString().padStart(2, "0"));
        options.push({
            label: time,
            value: time
        });
    }
    return options;
};
var TimePicker = function(param) {
    var id = param.id, type = param.type, label = param.label, value = param.value, onChange = param.onChange;
    var timeOptions = generateTimeRange();
    var handleChange = function(event) {
        onChange === null || onChange === void 0 ? void 0 : onChange(event.target.value, type);
    };
    return /*#__PURE__*/ _jsx(UiLegacy.Dropdown, {
        id: id,
        label: label,
        value: value,
        options: timeOptions,
        onChange: handleChange,
        style: {
            cursor: "pointer"
        }
    });
};
export { TimePicker };
